module.exports = __webpack_public_path__ + "static/img/exhibitioninfo-top.4f14957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exhibitioninfo/exhibitioninfo-top.jpg
// module id = rS6Y
// module chunks = 1